import React from 'react';
import noContent from '@static/empty-state-sep-21.png';
import { INBOX_NO_CONTENT_TITLE } from '@app/constants/texts';
import { Container, Image } from './MessageTableNoContent.styled';

const MessageTableNoContent = () => (
  <>
    <Container data-testid="dm-without-message">
      <Image src={noContent} alt="Student" sx={{ transform: 'scale(.9)' }} />
      {INBOX_NO_CONTENT_TITLE}
    </Container>
  </>
);

export default MessageTableNoContent;
